import type { webpageInfo } from "~/types/api/client/webpages";
import { ContentAPI } from "./content/contentapi";

export class WebpageAPI {
    clientId: number;
    websiteId: number;
    webpageId: number;
    content: ContentAPI

    constructor(clientId: number, websiteId: number, webpageId: number) {
        this.clientId = clientId;
        this.websiteId = websiteId;
        this.webpageId = webpageId;
        this.content = new ContentAPI(this.clientId, this.websiteId, this.webpageId)
    }

    async getWebpageInfo(): Promise<webpageInfo> {
        const response = await $fetch<webpageInfo>(`/api/client/webpageinfo?clientid=${this.clientId}&websiteid=${this.websiteId}&webpageid=${this.webpageId}`, {
            headers:useRequestHeaders(['cookie'])
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message} as unknown as webpageInfo
                default:
                    return {status: 0, message: 'No idea man'} as unknown as webpageInfo
            }
        })
        return response as webpageInfo;
    }

    async updateWebpageInfo(webpageInfo: webpageInfo): Promise<webpageInfo> {
        const response = await $fetch<webpageInfo>(`/api/client/webpageinfo?clientid=${this.clientId}&websiteid=${this.websiteId}&webpageid=${this.webpageId}`, {
            headers:useRequestHeaders(['cookie']),
            method: 'POST',
            body: {
                webPage_id: this.webpageId,
                webpageInfo: webpageInfo
            }
        })
        return response
    }

    async resetPageCache(webHostId: number): Promise<{ ok: boolean }> {
        const params = new URLSearchParams({
            clientid: String(this.clientId),
            websiteid: String(this.websiteId),
            webpageid: String(this.webpageId),
            webhostid: String(webHostId),
        })
        return await $fetch<{ ok: boolean }>(`/api/client/reset-page-cache?${params.toString()}`, {
            headers: useRequestHeaders(['cookie']),
            method: 'POST',
        })
    }

    async resetAllCache(webApplicationId: number, webHostId: number): Promise<{ ok: boolean }> {
        const params = new URLSearchParams({
            clientid: String(this.clientId),
            websiteid: String(this.websiteId),
            webapplicationid: String(webApplicationId),
            webhostid: String(webHostId),
        })
        return await $fetch<{ ok: boolean }>(`/api/client/reset-all-cache?${params.toString()}`, {
            headers: useRequestHeaders(['cookie']),
            method: 'POST',
        })
    }
}